import { apiUrl } from "../../../config";
import axios from "axios";

/**
 * Suivi du chiffre d'affaires (AnalyseFinanciereController côté API).
 * Tous les montants sont calculés par l'API, en HT : l'écran n'envoie que la
 * période et les options, jamais un montant.
 */

function entetes() {
  return {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("auth"),
  };
}

function lire(chemin, params) {
  return axios
    .get(apiUrl + "api/" + chemin, { headers: entetes(), params })
    .then((response) => response.data.data);
}

export const state = {};
export const mutations = {};
export const getters = {};

export const actions = {
  // { du, au, anterieures } → indicateurs + série mensuelle
  // eslint-disable-next-line no-unused-vars
  getAnalyseFinanciere({ commit }, params) {
    return lire("analyse-financiere", params);
  },

  // { indicateur: facture | encaisse | reste, du, au, anterieures, seulement_anterieures }
  // eslint-disable-next-line no-unused-vars
  getDocumentsAnalyse({ commit }, params) {
    return lire("analyse-financiere/documents", params);
  },

  // { ids, date: "facture" | "AAAA-MM-JJ", mode } : rattrapage des factures antérieures
  // eslint-disable-next-line no-unused-vars
  marquerAnterieuresPayees({ commit }, data) {
    return axios
      .post(apiUrl + "api/analyse-financiere/anterieures/marquer-payees", data, { headers: entetes() })
      .then((response) => response.data.data);
  },
};
